export class AssignedPackageSession {
    id: string;
    createdOn: string;
    source?: string;
    sourceId?: string;
    periodEnd?: number;
    timestamp?: string;
}

export class ScheduledSession {
    id: string;
    createdOn: string;
    source: string;
}

export class  AssignedPackage {
    
    id: string;
    activeDate?: string;
    cancelationDate?: string;
    createdBy: string;
    creationDate: string;
    currentPeriodEnd: number;
    currentPeriodStart: number;
    description?: string;
    discount: string;
    interval: "day" | "week" | "month" | "year";
    invervalCount: number;
    organization: string;
    purchaseDate?: string;
    product: string;
    provider?: "stripe";
    price: string;
    priceAmount: number;
    priceType: "oneTime" | "recurring";
    image?: string;
    trainer?: string;
    stripeAccount?: string;
    sessions: string;
    sessionsArchived: {
        [sessionId: string]: Partial<AssignedPackage>;
    };
    sessionsScheduled: {
        [referenceId: string]: Partial<ScheduledSession>
    }
    sessionsUsed: {
        [sessionId: string]: Partial<AssignedPackage>;
    };
    sessionLength: number;
    subscription?: string;
    subtitle?: string;
    status: string;
    termsAccepted: boolean;
    title: string;
    user: string;
    userName: string;

    constructor (init: Partial<AssignedPackage>){
        Object.assign(this, init);
    }

    getSessions(): AssignedPackageSession[] {
        const toReturn = [];
        if(this.sessionsUsed) {
            const keys = Object.keys(this.sessionsUsed);

            for (const key of keys) {
                toReturn.push({
                    id: key,
                    ...this.sessionsUsed[key],
                });
            }
        } 
        if(this.sessionsArchived) {
            const keys = Object.keys(this.sessionsArchived);

            for (const key of keys) {
                toReturn.push({
                    id: key,
                    ...this.sessionsArchived[key],
                });
            }
        } 
        return toReturn;
    }

    getScheduledSessions(): ScheduledSession[] {
        const toReturn = [];
        if(this.sessionsScheduled) {
            const keys = Object.keys(this.sessionsScheduled);
            for (const key of keys) {
                toReturn.push({
                    id: key,
                    ...this.sessionsScheduled[key],
                });
            }
        }
        return toReturn
    }

    getRemainingSessions(): number {
        if(this.subscription && this.currentPeriodEnd) {
            const allSessions = this.getSessions().filter(session => {return session.periodEnd === this.currentPeriodEnd});
            return parseInt(this.sessions) - allSessions.length
        } else {
            return parseInt(this.sessions) - ((this.sessionsUsed? Object.keys(this.sessionsUsed).length : 0) + (this.sessionsScheduled? Object.keys(this.sessionsScheduled).length : 0)); 
        }
    }

    getStatus() {
        if(this.sessions) {
            return this.getRemainingSessions() > 0? "active" : "complete"
        } else {
            return this.status
        }
    }
}